module.exports = "/static-assets/_next/static/images/earnCheddar-41d92d83c934e7dafe3edf28313d09de.png";